export const GET_STATES_START = 'GET_STATES_START';
export const GET_STATES_SUCCESS = 'GET_STATES_SUCCESS';
export const GET_STATES_FAIL = 'GET_STATES_FAIL';

export const GET_CARRIERS_START = 'GET_CARRIERS_START';
export const GET_CARRIERS_SUCCESS = 'GET_CARRIERS_SUCCESS';
export const GET_CARRIERS_FAIL = 'GET_CARRIERS_FAIL';

export const GET_LOCATIONS_START = 'GET_LOCATIONS_START';
export const GET_LOCATIONS_SUCCESS = 'GET_LOCATIONS_SUCCESS';
export const GET_LOCATIONS_FAIL = 'GET_LOCATIONS_FAIL';

export const GET_LOB_CLASSES_START = 'GET_LOB_CLASSES_START';
export const GET_LOB_CLASSES_SUCCESS = 'GET_LOB_CLASSES_SUCCESS';
export const GET_LOB_CLASSES_FAIL = 'GET_LOB_CLASSES_FAIL';

export const GET_LINES_OF_BUSINESS_START = 'GET_LINES_OF_BUSINESS_START';
export const GET_LINES_OF_BUSINESS_SUCCESS = 'GET_LINES_OF_BUSINESS_SUCCESS';
export const GET_LINES_OF_BUSINESS_FAIL = 'GET_LINES_OF_BUSINESS_FAIL';

export const GET_REFERRAL_SOURCES_START = 'GET_REFERRAL_SOURCES_START';
export const GET_REFERRAL_SOURCES_SUCCESS = 'GET_REFERRAL_SOURCES_SUCCESS';
export const GET_REFERRAL_SOURCES_FAIL = 'GET_REFERRAL_SOURCES_FAIL';

export const GET_TAGS_START = 'GET_TAGS_START';
export const GET_TAGS_SUCCESS = 'GET_TAGS_SUCCESS';
export const GET_TAGS_FAIL = 'GET_TAGS_FAIL';

export const GET_QUOTE_STAGES_START = 'GET_QUOTE_STAGES_START';
export const GET_QUOTE_STAGES_SUCCESS = 'GET_QUOTE_STAGES_SUCCESS';
export const GET_QUOTE_STAGES_FAIL = 'GET_QUOTE_STAGES_FAIL';

export const GET_MGAS_START = 'GET_MGAS_START';
export const GET_MGAS_SUCCESS = 'GET_MGAS_SUCCESS';
export const GET_MGAS_FAIL = 'GET_MGAS_FAIL';

export const GET_RENEWAL_TYPES_START = 'GET_RENEWAL_TYPES_START';
export const GET_RENEWAL_TYPES_SUCCESS = 'GET_RENEWAL_TYPES_SUCCESS';
export const GET_RENEWAL_TYPES_FAIL = 'GET_RENEWAL_TYPES_FAIL';

export const GET_OPPORTUNITY_STAGES_START = 'GET_OPPORTUNITY_STAGES_START';
export const GET_OPPORTUNITY_STAGES_SUCCESS = 'GET_OPPORTUNITY_STAGES_SUCCESS';
export const GET_OPPORTUNITY_STAGES_FAIL = 'GET_OPPORTUNITY_STAGES_FAIL';

export const GET_POLICY_SEARCH_FILTER_STATUSES_START = 'GET_POLICY_SEARCH_FILTER_STATUSES_START';
export const GET_POLICY_SEARCH_FILTER_STATUSES_SUCCESS = 'GET_POLICY_SEARCH_FILTER_STATUSES_SUCCESS';
export const GET_POLICY_SEARCH_FILTER_STATUSES_FAIL = 'GET_POLICY_SEARCH_FILTER_STATUSES_FAIL';

export const GET_QUOTE_SEARCH_FILTER_STATUSES_START = 'GET_QUOTE_SEARCH_FILTER_STATUSES_START';
export const GET_QUOTE_SEARCH_FILTER_STATUSES_SUCCESS = 'GET_QUOTE_SEARCH_FILTER_STATUSES_SUCCESS';
export const GET_QUOTE_SEARCH_FILTER_STATUSES_FAIL = 'GET_QUOTE_SEARCH_FILTER_STATUSES_FAIL';

export const GET_AGENCY_NAME_START = 'GET_AGENCY_NAME_START';
export const GET_AGENCY_NAME_SUCCESS = 'GET_AGENCY_NAME_SUCCESS';
export const GET_AGENCY_NAME_FAIL = 'GET_AGENCY_NAME_FAIL';

export const SHARED_GET_POLICIES_LOOKUP_START = 'SHARED_GET_POLICIES_LOOKUP_START';
export const SHARED_GET_POLICIES_LOOKUP_SUCCESS = 'SHARED_GET_POLICIES_LOOKUP_SUCCESS';
export const SHARED_GET_POLICIES_LOOKUP_FAIL = 'SHARED_GET_POLICIES_LOOKUP_FAIL';

export const GET_PERMISSIONS_START = 'GET_PERMISSIONS_START';
export const GET_PERMISSIONS_SUCCESS = 'GET_PERMISSIONS_SUCCESS';
export const GET_PERMISSIONS_FAIL = 'GET_PERMISSIONS_FAIL';

export const HAS_ACCESS_TO_INFUSION_SOFT_START = 'HAS_ACCESS_TO_INFUSION_SOFT_START';
export const HAS_ACCESS_TO_INFUSION_SOFT_SUCCESS = 'HAS_ACCESS_TO_INFUSION_SOFT_SUCCESS';
export const HAS_ACCESS_TO_INFUSION_SOFT_FAIL = 'HAS_ACCESS_TO_INFUSION_SOFT_FAIL';

export const GET_PROSPECT_STATUSES_START = 'GET_PROSPECT_STATUSES_START';
export const GET_PROSPECT_STATUSES_SUCCESS = 'GET_PROSPECT_STATUSES_SUCCESS';
export const GET_PROSPECT_STATUSES_FAIL = 'GET_PROSPECT_STATUSES_FAIL';

export const GET_PARENT_CARRIERS_START = 'GET_PARENT_CARRIERS_START';
export const GET_PARENT_CARRIERS_SUCCESS = 'GET_PARENT_CARRIERS_SUCCESS';
export const GET_PARENT_CARRIERS_FAIL = 'GET_PARENT_CARRIERS_FAIL';

export const GET_MAX_FILE_UPLOAD_SIZE_START = 'GET_MAX_FILE_UPLOAD_SIZE_START';
export const GET_MAX_FILE_UPLOAD_SIZE_SUCCESS = 'GET_MAX_FILE_UPLOAD_SIZE_SUCCESS';
export const GET_MAX_FILE_UPLOAD_SIZE_FAIL = 'GET_MAX_FILE_UPLOAD_SIZE_FAIL';

export const GET_STATUS_OF_AGENCY_MODULES_START = 'GET_STATUS_OF_AGENCY_MODULES_START';
export const GET_STATUS_OF_AGENCY_MODULES_SUCCESS = 'GET_STATUS_OF_AGENCY_MODULES_SUCCESS';
export const GET_STATUS_OF_AGENCY_MODULES_FAIL = 'GET_STATUS_OF_AGENCY_MODULES_FAIL';

export const GET_USERS_START = 'GET_USERS_START';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAIL = 'GET_USERS_FAIL';

export const GET_PROPERTY_TYPES_START = 'GET_PROPERTY_TYPES_START';
export const GET_PROPERTY_TYPES_SUCCESS = 'GET_PROPERTY_TYPES_SUCCESS';
export const GET_PROPERTY_TYPES_FAIL = 'GET_PROPERTY_TYPES_FAIL';

export const GET_SERVICE_REQUEST_STATUSES_START = 'GET_SERVICE_REQUEST_STATUSES_START';
export const GET_SERVICE_REQUEST_STATUSES_SUCCESS = 'GET_SERVICE_REQUEST_STATUSES_SUCCESS';
export const GET_SERVICE_REQUEST_STATUSES_FAIL = 'GET_SERVICE_REQUEST_STATUSES_FAIL';

export const SHARED_GET_INSUREDS_BY_AGENCY_START = 'SHARED_GET_INSUREDS_START';
export const SHARED_GET_INSUREDS_BY_AGENCY_SUCCESS = 'SHARED_GET_INSUREDS_SUCCESS';
export const SHARED_GET_INSUREDS_BY_AGENCY_FAIL = 'SHARED_GET_INSUREDS_FAIL';

export const SHARED_GET_CLAIMS_START = 'SHARED_GET_CLAIMS_START';
export const SHARED_GET_CLAIMS_SUCCESS = 'SHARED_GET_CLAIMS_SUCCESS';
export const SHARED_GET_CLAIMS_FAIL = 'SHARED_GET_CLAIMS_FAIL';

export const SHARED_GET_INSURED_CONTACTS_LOOKUP_START = 'SHARED_GET_INSURED_CONTACTS_LOOKUP_START';
export const SHARED_GET_INSURED_CONTACTS_LOOKUP_SUCCESS = 'SHARED_GET_INSURED_CONTACTS_LOOKUP_SUCCESS';
export const SHARED_GET_INSURED_CONTACTS_LOOKUP_FAIL = 'SHARED_GET_INSURED_CONTACTS_LOOKUP_FAIL';

export const SHARED_GET_INSURED_CONTACTS_OWNERS_LOOKUP_START = 'SHARED_GET_INSURED_CONTACTS_OWNERS_LOOKUP_START';
export const SHARED_GET_INSURED_CONTACTS_OWNERS_LOOKUP_SUCCESS = 'SHARED_GET_INSURED_CONTACTS_OWNERS_LOOKUP_SUCCESS';
export const SHARED_GET_INSURED_CONTACTS_OWNERS_LOOKUP_FAIL = 'SHARED_GET_INSURED_CONTACTS_OWNERS_LOOKUP_FAIL';

export const SHARED_GET_DRIVERS_LOOKUP_START = 'SHARED_GET_DRIVERS_LOOKUP_START';
export const SHARED_GET_DRIVERS_LOOKUP_SUCCESS = 'SHARED_GET_DRIVERS_LOOKUP_SUCCESS';
export const SHARED_GET_DRIVERS_LOOKUP_FAIL = 'SHARED_GET_DRIVERS_LOOKUP_FAIL';

export const SHARED_GET_VEHICLES_LOOKUP_START = 'SHARED_GET_VEHICLES_LOOKUP_START';
export const SHARED_GET_VEHICLES_LOOKUP_SUCCESS = 'SHARED_GET_VEHICLES_LOOKUP_SUCCESS';
export const SHARED_GET_VEHICLES_LOOKUP_FAIL = 'SHARED_GET_VEHICLES_LOOKUP_FAIL';

export const REPLACE_MESSAGE_PLACEHOLDERS_START = 'REPLACE_MESSAGE_PLACEHOLDERS_START';
export const REPLACE_MESSAGE_PLACEHOLDERS_SUCCESS = 'REPLACE_MESSAGE_PLACEHOLDERS_SUCCESS';
export const REPLACE_MESSAGE_PLACEHOLDERS_FAIL = 'REPLACE_MESSAGE_PLACEHOLDERS_FAIL';

export const SHARED_GET_MOTOR_TRUCK_CARGOS_LOOKUP_START = 'SHARED_GET_MOTOR_TRUCK_CARGOS_LOOKUP_START';
export const SHARED_GET_MOTOR_TRUCK_CARGOS_LOOKUP_SUCCESS = 'SHARED_GET_MOTOR_TRUCK_CARGOS_LOOKUP_SUCCESS';
export const SHARED_GET_MOTOR_TRUCK_CARGOS_LOOKUP_FAIL = 'SHARED_GET_MOTOR_TRUCK_CARGOS_LOOKUP_FAIL';

export const SHARED_GET_PENDING_CANCELLATIONS_LOOKUP_START = 'SHARED_GET_PENDING_CANCELLATIONS_LOOKUP_START';
export const SHARED_GET_PENDING_CANCELLATIONS_LOOKUP_SUCCESS = 'SHARED_GET_PENDING_CANCELLATIONS_LOOKUP_SUCCESS';
export const SHARED_GET_PENDING_CANCELLATIONS_LOOKUP_FAIL = 'SHARED_GET_PENDING_CANCELLATIONS_LOOKUP_FAIL';

export const SHARED_GET_TRUCKING_COMPANY_CONTACTS_LOOKUP_START = 'SHARED_GET_TRUCKING_COMPANY_CONTACTS_LOOKUP_START';
export const SHARED_GET_TRUCKING_COMPANY_CONTACTS_LOOKUP_SUCCESS = 'SHARED_GET_TRUCKING_COMPANY_CONTACTS_LOOKUP_SUCCESS';
export const SHARED_GET_TRUCKING_COMPANY_CONTACTS_LOOKUP_FAIL = 'SHARED_GET_TRUCKING_COMPANY_CONTACTS_LOOKUP_FAIL';

export const SHARED_GET_WORKERS_COMPENSATIONS_LOOKUP_START = 'SHARED_GET_WORKERS_COMPENSATIONS_LOOKUP_START';
export const SHARED_GET_WORKERS_COMPENSATIONS_LOOKUP_SUCCESS = 'SHARED_GET_WORKERS_COMPENSATIONS_LOOKUP_SUCCESS';
export const SHARED_GET_WORKERS_COMPENSATIONS_LOOKUP_FAIL = 'SHARED_GET_WORKERS_COMPENSATIONS_LOOKUP_FAIL';

export const SHARED_GET_PROPERTIES_LOOKUP_START = 'SHARED_GET_PROPERTIES_LOOKUP_START';
export const SHARED_GET_PROPERTIES_LOOKUP_SUCCESS = 'SHARED_GET_PROPERTIES_LOOKUP_SUCCESS';
export const SHARED_GET_PROPERTIES_LOOKUP_FAIL = 'SHARED_GET_PROPERTIES_LOOKUP_FAIL';

export const SHARED_GET_ADDITIONAL_INTERESTS_LOOKUP_START = 'SHARED_GET_ADDITIONAL_INTERESTS_LOOKUP_START';
export const SHARED_GET_ADDITIONAL_INTERESTS_LOOKUP_SUCCESS = 'SHARED_GET_ADDITIONAL_INTERESTS_LOOKUP_SUCCESS';
export const SHARED_GET_ADDITIONAL_INTERESTS_LOOKUP_FAIL = 'SHARED_GET_ADDITIONAL_INTERESTS_LOOKUP_FAIL';

export const SHARED_GET_GENERAL_LIABILITIES_LOOKUP_START = 'SHARED_GET_GENERAL_LIABILITIES_LOOKUP_START';
export const SHARED_GET_GENERAL_LIABILITIES_LOOKUP_SUCCESS = 'SHARED_GET_GENERAL_LIABILITIES_LOOKUP_SUCCESS';
export const SHARED_GET_GENERAL_LIABILITIES_LOOKUP_FAIL = 'SHARED_GET_GENERAL_LIABILITIES_LOOKUP_FAIL';

export const SHARED_GET_SCHEDULE_OF_HAZARDS_LOOKUP_START = 'SHARED_GET_SCHEDULE_OF_HAZARDS_LOOKUP_START';
export const SHARED_GET_SCHEDULE_OF_HAZARDS_LOOKUP_SUCCESS = 'SHARED_GET_SCHEDULE_OF_HAZARDS_LOOKUP_SUCCESS';
export const SHARED_GET_SCHEDULE_OF_HAZARDS_LOOKUP_FAIL = 'SHARED_GET_SCHEDULE_OF_HAZARDS_LOOKUP_FAIL';

export const SHARED_GET_EQUIPMENTS_LOOKUP_START = 'SHARED_GET_EQUIPMENTS_LOOKUP_START';
export const SHARED_GET_EQUIPMENTS_LOOKUP_SUCCESS = 'SHARED_GET_EQUIPMENTS_LOOKUP_SUCCESS';
export const SHARED_GET_EQUIPMENTS_LOOKUP_FAIL = 'SHARED_GET_EQUIPMENTS_LOOKUP_FAIL';

export const SHARED_GET_AGENTS_LOOKUP_START = 'SHARED_GET_AGENTS_LOOKUP_START';
export const SHARED_GET_AGENTS_LOOKUP_SUCCESS = 'SHARED_GET_AGENTS_LOOKUP_SUCCESS';
export const SHARED_GET_AGENTS_LOOKUP_FAIL = 'SHARED_GET_AGENTS_LOOKUP_FAIL';

export const SHARED_GET_QUOTES_LOOKUP_START = 'SHARED_GET_QUOTES_LOOKUP_START';
export const SHARED_GET_QUOTES_LOOKUP_SUCCESS = 'SHARED_GET_QUOTES_LOOKUP_SUCCESS';
export const SHARED_GET_QUOTES_LOOKUP_FAIL = 'SHARED_GET_QUOTES_LOOKUP_FAIL';

export const SHARED_GET_SIGNATURES_LOOKUP_START = 'SHARED_GET_SIGNATURES_LOOKUP_START';
export const SHARED_GET_SIGNATURES_LOOKUP_SUCCESS = 'SHARED_GET_SIGNATURES_LOOKUP_SUCCESS';
export const SHARED_GET_SIGNATURES_LOOKUP_FAIL = 'SHARED_GET_SIGNATURES_LOOKUP_FAIL';

export const SHARED_GET_AUTOMOBILE_LIABILITY_COVERAGE_SECTION_TYPES_TYPES_START =
  'SHARED_GET_AUTOMOBILE_LIABILITY_COVERAGE_SECTION_TYPES_TYPES_START';
export const SHARED_GET_AUTOMOBILE_LIABILITY_COVERAGE_SECTION_TYPES_TYPES_SUCCESS =
  'SHARED_GET_AUTOMOBILE_LIABILITY_COVERAGE_SECTION_TYPES_TYPES_SUCCESS';
export const SHARED_GET_AUTOMOBILE_LIABILITY_COVERAGE_SECTION_TYPES_TYPES_FAIL = 'SHARED_GET_AUTOMOBILE_LIABILITY_COVERAGE_SECTION_TYPES_TYPES_FAIL';

export const SHARED_GET_BOATS_LOOKUP_START = 'SHARED_GET_BOATS_LOOKUP_START';
export const SHARED_GET_BOATS_LOOKUP_SUCCESS = 'SHARED_GET_BOATS_LOOKUP_SUCCESS';
export const SHARED_GET_BOATS_LOOKUP_FAIL = 'SHARED_GET_BOATS_LOOKUP_FAIL';

export const SHARED_GET_USER_INFO_START = 'SHARED_GET_USER_INFO_START';
export const SHARED_GET_USER_INFO_SUCCESS = 'SHARED_GET_USER_INFO_SUCCESS';
export const SHARED_GET_USER_INFO_FAIL = 'SHARED_GET_USER_INFO_FAIL';

export const SHARED_GET_FORM_NAME_START = 'SHARED_GET_FORM_NAME_START';
export const SHARED_GET_FORM_NAME_SUCCESS = 'SHARED_GET_FORM_NAME_SUCCESS';
export const SHARED_GET_FORM_NAME_FAIL = 'SHARED_GET_FORM_NAME_FAIL';

export const WEB_SOCKET_SET_REMAINDER_NOTIFICATION_MESSAGE = 'WEB_SOCKET_SET_REMAINDER_NOTIFICATION_MESSAGE';

export const WEB_SOCKET_SET_UNREAD_MESSAGE = 'WEB_SOCKET_SET_UNREAD_MESSAGE';

export const WEB_SOCKET_SET_SMS_MESSAGE = 'WEB_SOCKET_SET_SMS_MESSAGE';

export const WEB_SOCKET_SEND_MESSAGE = 'WEB_SOCKET_SEND_MESSAGE';

export const SHARED_GET_BUSINESS_AUTO_ACORD_137s_LOOKUP_START = 'SHARED_GET_BUSINESS_AUTO_ACORD_137s_LOOKUP_START';
export const SHARED_GET_BUSINESS_AUTO_ACORD_137s_LOOKUP_SUCCESS = 'SHARED_GET_BUSINESS_AUTO_ACORD_137s_LOOKUP_SUCCESS';
export const SHARED_GET_BUSINESS_AUTO_ACORD_137s_LOOKUP_FAIL = 'SHARED_GET_BUSINESS_AUTO_ACORD_137s_LOOKUP_FAIL';

export const SHARED_GET_PERSONAL_UMBRELLAS_LOOKUP_START = 'SHARED_GET_PERSONAL_UMBRELLAS_LOOKUP_START';
export const SHARED_GET_PERSONAL_UMBRELLAS_LOOKUP_SUCCESS = 'SHARED_GET_PERSONAL_UMBRELLAS_LOOKUP_SUCCESS';
export const SHARED_GET_PERSONAL_UMBRELLAS_LOOKUP_FAIL = 'SHARED_GET_PERSONAL_UMBRELLAS_LOOKUP_FAIL';

export const SHARED_GET_COMMERCIAL_UMBRELLAS_LOOKUP_START = 'SHARED_GET_COMMERCIAL_UMBRELLAS_LOOKUP_START';
export const SHARED_GET_COMMERCIAL_UMBRELLAS_LOOKUP_SUCCESS = 'SHARED_GET_COMMERCIAL_UMBRELLAS_LOOKUP_SUCCESS';
export const SHARED_GET_COMMERCIAL_UMBRELLAS_LOOKUP_FAIL = 'SHARED_GET_COMMERCIAL_UMBRELLAS_LOOKUP_FAIL';

export const WEB_SOCKET_CLEAR_BUFFER_OF_MESSAGE_TO_SEND = 'WEB_SOCKET_CLEAR_BUFFER_OF_MESSAGE_TO_SEND';
export const WEB_SOCKET_ADD_MESSAGE_TO_BUFFER = 'WEB_SOCKET_ADD_MESSAGE_TO_BUFFER';
